module.exports = __webpack_public_path__ + "img/jxk-icon1.98a85780.png";